module.exports = __webpack_public_path__ + "assets/img/litsone.b41cd2f3.png";